<template>
  <div class="body">
    <div class="detay">
      <div class="sayfahead tek">
        <h1>Raporlar</h1>
        <el-button-group class="float-right YeniBtn">
          <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                       to="/raporlama/bina" type="default">
            Bina Raporu
          </router-link>
          <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                       to="/raporlama/sayac" type="default">
            Arızalı Sayaç Raporu
          </router-link>
          <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                       to="/raporlama/teknik" type="default">
            Teknik Destek
          </router-link>
          <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                       to="/raporlama/uo" type="default">
            4G Cihaz
          </router-link>
          <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                       to="/raporlama/telegram" type="default">
            Telegram
          </router-link>
          <router-link v-if="this.$store.getters.Yetki.muhasebe>0" tag="el-button" class="el-button--small"
                       active-class="el-button--primary"
                       to="/raporlama/fatura" type="default">
            Fatura
          </router-link>
          <router-link v-if="this.$store.getters.Yetki.muhasebe>0" tag="el-button" class="el-button--small"
                       active-class="el-button--primary"
                       to="/raporlama/lazerfatura" type="default">
            Lazer Fatura
          </router-link>
        </el-button-group>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  created() {
    if (this.$store.getters.raporlama == '0') this.$router.push("/403");
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Raporlama/_route.vue